<template>
    <div class="container-fluid text-center conecta2-logo">
        <div class="row justify-content-start">
            <div class="col-lg-12 col-md-12 col-12  align-self-center ">
                <div class="logo-img">
                    <img class="img-fluid" src="/img-version2/brand/logo-conecta2.svg">
                </div>

                <form @submit.prevent="loginUser" method="post">

                    <div class="form-group">
                        <label for="user">Cédula</label>
                        <input class="form-control my-1" v-model="identificationNumber" autofocus type="text">
                    </div>

                    <div class="form-group mt-3">
                        <label for="pass">Contraseña</label>
                        <div class="pass form-group position-relative">
                            <input ref="pass" class="form-control my-1" type="password" v-model="secretString"
                                autocomplete="off">
                            <div class="eye-container" @click="showPassword">
                                <div :class="{'cross-eye': true, 'opacity-100': isPasswordShown}"></div>
                                <div id="eye" class="eye"></div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group mt-2" id="rememberMeGroup">
                        <div class="controls d-flex justify-content-around">
                            <div>
                                <input type="checkbox" name="remember" id="remember" value="1">
                                <label for="remember" class="remember-me-text ml-2">Recuérdame</label>
                            </div>

                            <label class="text-right">
                                <strong><a href="/recordar-password-admin">Olvidé mi contraseña</a></strong>
                            </label>
                        </div>
                    </div>

                    <div class="btnLogin">
                        <button type="button" @click="verifyUser" class="btnBlue login-button">
                            Ingresar
                        </button>
                    </div>

                    <div class="text-center">
                        <el-dialog :visible="activeOtpDialog" :close-on-click-modal="false" :show-close="false"
                            width="500" :align-center="true" :center="true">
                            <p class="text-center text-dark fs-3 fw-bold mb-4 text-title-bat">Autenticación en dos
                                pasos</p>
                            <div class="d-flex flex-column align-items-center" style="width: 90%; margin: 0 auto;">
                                <label class="text-dark mb-3 text-bat text-center" for="otp">Al correo <strong>{{ formatedUserEmail
                                        }}</strong> registrado a este usuario, se enviará un <strong>código</strong>
                                    de 4 dígitos necesario para iniciar sesión en el admin</label>
                                <div class="d-flex flex-row justify-content-center gap-2">
                                    <input v-for="(index, key) in otpSequence" :key="key" type="number" min="0" max="9"
                                        class="form-control no-spinner mb-1 text-center"
                                        style="width: calc(40rem / 16); height: calc(40rem / 16); font-size: 1.2rem;"
                                        autocomplete="off" v-model="otpSequence[key]" :ref="'otp' + key"
                                        :id="'otp' + key" @input="toggleLoginButton(key)" required />
                                </div>

                                <button class="btn btn-outline-danger btn-sm m-1" style="font-size: 0.7rem;"
                                    @click="cleanOtpInputs" type="button">Limpiar</button>
                                <p class="text-danger mb-3" style="font-size: 0.8rem;" v-if="otpErrorMessage">{{
                                    otpErrorMessage }}</p>
                                <p class="text-success mb-3" style="font-size: 0.8rem;" v-if="otpSuccessMessage">{{
                                    otpSuccessMessage }}</p>

                                <div class="d-flex flex-row justify-content-center align-items-center text-secondary-emphasis fw-lighter gap-2 my-2"
                                    style="font-size: 0.9rem;">
                                    <p v-if="!enableGenerateCodeButton" class="my-0 text-bat"
                                        style="font-size: inherit;">
                                        Tiempo restante: {{ timer }}
                                    </p>
                                    <div v-if="enableGenerateCodeButton"
                                        class="d-flex justify-content-center align-items-center gap-1">
                                        <p class="my-0" style="font-size: inherit;">El código ha expirado. Para generar
                                            uno nuevo, haga </p>
                                        <button class="btn btn-link p-0" @click="generateNewCode"
                                            style="font-size: inherit; border: 0;">click aquí.</button>
                                    </div>
                                </div>
                            </div>
                            <template #footer>
                                <div class="dialog-footer mb-3 d-flex flex-column-reverse">
                                    <div>
                                        <a type="button" class="w-50 fs-6 mt-4 border-2 text-btn-outstanding"
                                        @click="activeOtpDialog = false">Cancelar</a>
                                    </div>
                                    <div>
                                        <button class="w-50 mx-1 btn btnBlue text-title-bat rounded-3" id="loginButton"
                                            :disabled="disableLoginButton" ref="login">
                                            Ingresar
                                        </button>
                                    </div>
                                </div>
                            </template>
                        </el-dialog>
                    </div>
                </form>

                <ul class="list-unstyled">
                    <li v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</li>
                    <li v-if="successMessage" class="alert alert-success">{{ successMessage }}</li>
                </ul>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isPasswordShown: false,
                identificationNumber: '',
                secretString: '',
                errorMessage: '',
                otpErrorMessage: '',
                successMessage: '',
                otpSuccessMessage: '',
                activeOtpDialog: false,
                disableLoginButton: true,
                otpSequence: ['', '', '', ''],
                finalOtp: '',
                timer: '',
                isTimerActive: false,
                enableGenerateCodeButton: false,
                formatedUserEmail: ''
            }
        },
        methods: {
            showPassword() {
                this.isPasswordShown = !this.isPasswordShown
                this.$refs.pass.type = this.isPasswordShown ? 'text' : 'password'
            },
            calculateTime(timeInSeconds = 120) {
                let minutes = Math.floor(timeInSeconds / 60)
                let seconds = timeInSeconds - (60 * minutes)
                this.isTimerActive = true
                this.timer = `${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`

                const timeInterval = setInterval(() => {
                    timeInSeconds--
                    seconds--

                    if (seconds < 0 && timeInSeconds > 0) {
                        minutes = Math.floor(timeInSeconds / 60)
                        seconds = 59
                    }

                    this.timer = `${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`

                    if (timeInSeconds === 0) {
                        this.isTimerActive = false
                        this.enableGenerateCodeButton = true
                        clearInterval(timeInterval);
                    }
                }, 1000)
            },
            toggleLoginButton(key) {
                const input = document.querySelector(`#otp${key+1}`)

                const currentLength = this.otpSequence[key].length

                if (currentLength > 1) {
                    this.otpSequence[key] = this.otpSequence[key][0]
                    if (key < this.otpSequence.length - 1) input.focus()
                }

                if (key < this.otpSequence.length - 1 && currentLength === 1) {
                    input.focus()
                }

                if (this.otpSequence.join('').length === 4) {
                    this.finalOtp = this.otpSequence.join('')
                    this.disableLoginButton = false
                    this.$nextTick(() => {
                        document.querySelector('#loginButton').focus()
                    })
                } else {
                    this.finalOtp = ''
                    this.disableLoginButton = true
                }

                this.otpErrorMessage = ''
            },
            resetOtpSequence() {
                this.otpSequence = this.otpSequence.map(sequence => sequence = '')
            },
            cleanOtpInputs() {
                this.resetOtpSequence()
                document.querySelector('#otp0').focus()
                this.disableLoginButton = true
            },
            generateNewCode() {
                this.enableGenerateCodeButton = false
                this.timer = 'Enviando código...'
                this.generateOtp()
                document.querySelector('#otp0').focus()
                this.resetOtpSequence()
            },
            activateOtpModal() {
                if (this.identificationNumber && this.secretString) {
                    this.activeOtpDialog = true
                    this.$nextTick(() => {
                        document.querySelector('#otp0').focus()
                    })
                    this.resetOtpSequence()
                    if (!this.isTimerActive) {
                        this.timer = 'Enviando código...'
                        this.enableGenerateCodeButton = false
                        this.generateOtp()
                    }
                }
            },
            generateOtp() {
                axios.post('bat-admin-send-otp', this.getUserCredentials())
                    .then(({ data }) => {
                        const { status } = data.data

                        if (status === 200) {
                            this.errorMessage = ''
                            this.activeOtpDialog = true
                            this.isTimerActive = true
                            this.calculateTime()
                            console.log(data);
                        } else {
                            console.warn(data.data)
                        }
                    })
                    .catch(({ response }) => {
                        const { message } = response.data.data
                        this.errorMessage = message

                        console.error(response.data)
                    })
            },
            verifyUser() {
                if (!this.identificationNumber || !this.secretString) {
                    this.errorMessage = 'Debe ingresar clave y contraseña para entrar'
                    return
                }

                const userSesionData = this.getUserCredentials()

                axios.post('bat-admin-verify-user', userSesionData)
                    .then(({ data }) => {
                        const { status } = data.data

                        if (status === 200) {
                            this.errorMessage = ''
                            this.activateOtpModal()
                            this.formatedUserEmail = data.data.options.formatedEmail
                        } else {
                            console.log(data.data)
                        }
                    })
                    .catch(({ response }) => {
                        const { message } = response.data.data
                        this.errorMessage = message
                        this.$notify.error({
                            title: 'Error al verificar usuario',
                            message: message
                        })

                        console.error(response.data);
                    })
            },
            loginUser() {
                if (this.finalOtp.length === 4 && !isNaN(Number(this.finalOtp))) {
                    const userSesionData = this.getUserCredentials(String(this.finalOtp))
                    this.errorMessage = ''

                    axios.post('bat-admin-authenticate-custom', userSesionData)
                        .then(({ data }) => {
                            const { status } = data.data
                            const { message } = data.data

                            if (status === 200) {
                                this.errorMessage = ''
                                this.activateOtpDialog = false
                                this.otpSuccessMessage = `${message}, bienvenido.`
                                this.$notify.success({
                                    title: 'Bienvenido',
                                    message: message
                                })
                                this.disableLoginButton = true
                                window.location.href = '/bat-admin'
                            }
                            console.log(data);
                        })
                        .catch(({ response }) => {
                            const { message } = response.data.data
                            this.otpErrorMessage = message
                            this.$notify.error({
                                title: 'Error al iniciar sesión',
                                message: message
                            })
                            this.activateOtpDialog = false
                            this.resetOtpSequence()
                            document.querySelector('#otp0').focus()
                            this.finalOtp = ''
                            this.disableLoginButton = true

                            console.error(response.data);
                        })
                } else {
                    this.otpErrorMessage = 'Formato de código inválido. Por favor ingresar solo números.'
                    this.resetOtpSequence()
                }
            },
            getUserCredentials(otp = undefined) {
                if (otp) {
                    return {
                        'identification_number': this.identificationNumber,
                        'password': this.secretString,
                        'otp': otp
                    }
                }
                return {
                    'identification_number': this.identificationNumber,
                    'password': this.secretString
                }
            }
        }
    }
</script>
